import { Checkbox, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { screenReaderOnly } from '../../../common/utils/styles';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const checkboxStyles = css`
  margin-top: 24px;
`;
const CabinUpgradeOptOutCheckbox = _ref => {
  var _unselectedCabinUpgra;
  let {
    checkboxSelectionLabel,
    segmentKey,
    setSelectedCabinUpgradeOptions,
    setUnselectedCabinUpgrades,
    unselectedCabinUpgrades,
    originDestinationAirportAriaLabelText
  } = _ref;
  const handleCheckboxChange = isChecked => {
    setUnselectedCabinUpgrades(prev => ({
      ...prev,
      [segmentKey]: isChecked
    }));
    if (isChecked) {
      setSelectedCabinUpgradeOptions(prev => {
        const updatedSelections = Object.keys(prev).reduce((acc, key) => {
          if (!key.includes(segmentKey)) {
            return {
              ...acc,
              [key]: prev[key]
            };
          }
          return acc;
        }, {});
        return updatedSelections;
      });
    }
  };
  return /*#__PURE__*/_jsxs(Inline, {
    align: "end",
    alignY: "center",
    className: checkboxStyles,
    spacing: 8,
    children: [/*#__PURE__*/_jsx(Checkbox.Label, {
      htmlFor: segmentKey,
      children: checkboxSelectionLabel
    }), /*#__PURE__*/_jsx(Checkbox, {
      "aria-describedby": `${CABIN_UPGRADE.name}-checkbox-${segmentKey}`,
      checked: (_unselectedCabinUpgra = unselectedCabinUpgrades[segmentKey]) !== null && _unselectedCabinUpgra !== void 0 ? _unselectedCabinUpgra : false,
      id: segmentKey,
      onChange: e => {
        var _e$target;
        return handleCheckboxChange(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.checked);
      }
    }), /*#__PURE__*/_jsx("span", {
      className: screenReaderOnly,
      id: `${CABIN_UPGRADE.name}-checkbox-${segmentKey}`,
      children: originDestinationAirportAriaLabelText
    })]
  });
};
export default CabinUpgradeOptOutCheckbox;
//# sourceMappingURL=CabinUpgradeOptOutCheckbox.js.map